import dayjs from "../../dayjs";

export function formatDate(yyyymmdd: string) {
  return dayjs(yyyymmdd, "YYYYMMDD").format("DD.MM.YYYY");
}
